import { createContext, useContext } from 'react'
import noop from 'lib/function/noop'

export interface AddedItineraryItemLink {
  /** The assistant turn that performed the add, so the link only renders under that message. */
  messageId: string
  stopId: number
  dayId?: number
  itemId?: number
}

export interface AddedItineraryItemContextValue {
  addedItemLink: AddedItineraryItemLink | undefined
  viewAddedItem: () => void
}

const DEFAULT_ADDED_ITINERARY_ITEM: AddedItineraryItemContextValue = {
  addedItemLink: undefined,
  viewAddedItem: noop,
}

/**
 * Carries the "See updated itinerary" affordance for the assistant turn that just added to
 * the itinerary. Defaults to an inert value so chat surfaces outside the trip planner
 * (offer page assistant panel, isolated tests) can render messages without a provider.
 */
export const AddedItineraryItemContext = createContext<AddedItineraryItemContextValue>(
  DEFAULT_ADDED_ITINERARY_ITEM,
)

export function useAddedItineraryItem(): AddedItineraryItemContextValue {
  return useContext(AddedItineraryItemContext)
}
